import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ensureCmsCards, useCmsVersion } from '../cms/store'
import MediaImage from '../components/MediaImage'
import { revealDelay } from '../lib/reveal'
import { archiveMeta, storiesForPath } from '../data/content'
import { storyPath } from '../lib/paths'

const PAGE_SIZE = 10

export default function Archive() {
  useCmsVersion()
  const { pathname } = useLocation()

  useEffect(() => {
    void ensureCmsCards()
  }, [])
  const meta = archiveMeta[pathname]
  const items = storiesForPath(pathname)
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)

  useEffect(() => {
    setVisibleCount(PAGE_SIZE)
  }, [pathname])

  const visibleItems = items.slice(0, visibleCount)
  const hasMore = items.length > visibleCount

  if (!meta) return null

  return (
    <main className="py-[clamp(28px,4.5vw,60px)]">
      <div data-reveal>
        <p className="text-caps text-rose">{meta.kicker}</p>
        <h1 className="text-caps-hero mt-3 m-0 text-balance text-ink">{meta.title}</h1>
        <p className="mt-4 max-w-[42ch] leading-relaxed text-copy">{meta.dek}</p>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-x-16 md:grid-cols-2">
        {visibleItems.map((story, index) => {
          const isLook = story.category === 'Look Books'
          return (
            <Link
              key={story.slug}
              to={storyPath(story.slug)}
              data-reveal
              style={revealDelay((index % 2) * 0.08)}
              className="flex min-w-0 flex-col gap-4 border-b border-rule py-6 hover:text-rose sm:flex-row sm:gap-5"
            >
              {story.image ? (
                <MediaImage
                  src={story.image}
                  size="thumb"
                  alt={story.imageAlt || story.title}
                  className={`aspect-[4/5] w-full shrink-0 sm:aspect-auto sm:size-24 ${isLook ? 'bg-white object-contain object-center' : 'object-cover object-top'}`}
                />
              ) : (
                <span className="aspect-[4/5] w-full shrink-0 bg-sand sm:aspect-auto sm:size-24" />
              )}
              <span className="min-w-0">
                <span className="text-caps flex gap-3 text-stone">
                  <span className="text-rose">{story.category === 'Food' ? 'Recipes' : story.category}</span>
                  <span>{story.date}</span>
                </span>
                <span className="text-caps-h3 mt-2 block text-ink">{story.title}</span>
                <span className="mt-1 block text-base text-muted">{story.dek}</span>
              </span>
            </Link>
          )
        })}
      </div>
      {hasMore && (
        <div className="mt-12 flex justify-center">
          <button
            type="button"
            onClick={() => setVisibleCount((count) => count + PAGE_SIZE)}
            className="text-caps h-12 bg-ink px-8 text-white hover:bg-rose"
          >
            Load more
          </button>
        </div>
      )}
    </main>
  )
}
